module.exports = __webpack_public_path__ + "img/ebcb85b.png";